import React from 'react'
import { HelpIcon } from '@instacart/ids-core'
import { colors } from 'gin-and-tonic/foundation/colors'
import { fontWeight } from 'gin-and-tonic/foundation/fontWeight'
import { useDomainMessages } from 'domains/pickup-settings/utils/domain/intl'

export function RestartTourFooter({ onRedoTour }: { onRedoTour: () => void }) {
  const { restartButtonLabel } = useDomainMessages({
    restartButtonLabel: 'pickupSettingsDomain.tours.restartFooter.restartButtonLabel',
  })

  const messages = useDomainMessages(
    {
      description: 'pickupSettingsDomain.tours.restartFooter.description',
      restartButtonLabel: 'pickupSettingsDomain.tours.restartFooter.restartButtonLabel',
    },
    {
      restartButton: (
        <span
          css={{
            color: colors.PRIMARY.REGULAR,
            cursor: 'pointer',
            fontWeight: fontWeight.SEMIBOLD,
            padding: '0 5px',
          }}
          onClick={onRedoTour}
          id="restartTourBtn"
        >
          {restartButtonLabel}
        </span>
      ),
    }
  )
  return (
    <div css={{ display: 'flex', alignItems: 'center' }}>
      <HelpIcon size={20} css={{ marginRight: '2px' }} />
      {messages.description}
    </div>
  )
}
